'use client';

import { useSyncCart } from '@/hooks/use-sync-cart';

const SyncCartWrapper = ({ children }) => {
  useSyncCart();

  return children;
};

export default SyncCartWrapper;
